import React, { Component } from 'react';
import TopNav from '../components/TopNav';
import {pageReload} from '../util/PageReload';
import Axios from 'axios';
import { Redirect } from 'react-router-dom';
import LoginModal from './modal/LoginModal';

export default class LoginWithFirebase extends Component {
    constructor(props) {
        super(props)
        this.state = {

        }
        // firebase.analytics().logEvent('visit_LoginWithFirebase');
        this.firebaseUIConfig = {
            // Popup signin flow rather than redirect flow.
            signInFlow: this.isFacebookApp() ? 'redirect' : 'popup',

            // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
            callbacks: {
                // Avoid redirects after sign-in.
                signInSuccessWithAuthResult: (authResult, redirectUrl) => this.onFirebaseSignIn(authResult, redirectUrl),
            },
            // We will display Google and Facebook as auth providers.
            signInOptions: this.signInOptions()
        }
    }

    signInOptions = () => {
        const phoneLogin = {
            provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
            recaptchaParameters: {
                type: 'image', // 'audio'
                size: 'invisible', // 'normal', 'invisible' or 'compact'
                badge: 'bottomleft' //' bottomright' or 'inline' applies to invisible.
            },
            defaultCountry: 'MY', // Set default country to the United Kingdom (+44).
            // For prefilling the national number, set defaultNationNumber.
            // This will only be observed if only phone Auth provider is used since
            // for multiple providers, the NASCAR screen will always render first
            // with a 'sign in with phone number' button.
            defaultNationalNumber: '1234567890',
            // You can also pass the full phone number string instead of the
            // 'defaultCountry' and 'defaultNationalNumber'. However, in this case,
            // the first country ID that matches the country code will be used to
            // populate the country selector. So for countries that share the same
            // country code, the selected country may not be the expected one.
            // In that case, pass the 'defaultCountry' instead to ensure the exact
            // country is selected. The 'defaultCountry' and 'defaultNationaNumber'
            // will always have higher priority than 'loginHint' which will be ignored
            // in their favor. In this case, the default country will be 'GB' even
            // though 'loginHint' specified the country code as '+1'.
            loginHint: '+60123456789'
        }
        if (this.isWeChat()) {
            return [
                phoneLogin
            ]
        }
        else {
            return [
                {
                    provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                    scopes: [
                        'profile',
                        'email',
                    ],
                },
                {
                    provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
                    scopes: [
                        'public_profile',
                        'email',
                    ],
                },
                phoneLogin,
            ]
        }
    }

    isFacebookApp = () => {
        var ua = navigator.userAgent || navigator.vendor || window.opera;
        return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
    }

    isWeChat = () => {
        var ua = navigator.userAgent.toLowerCase()
        if(ua.match(/MicroMessenger/i)=="micromessenger") {return true;} else {return false;}
    }

    componentDidMount() {
        this.props.app.loadTableIfNull(this.props.tableId);
        this.unregisterAuthObserver = firebase.auth().onAuthStateChanged(
            (user) => {
                // console.log(user)
            })
        // this.ui = new firebaseui.auth.AuthUI(firebase.auth())
        // this.startFirebase()
    }

    startFirebase() {
        if ($('#firebaseui-login-container').length) {
            this.ui.start('#firebaseui-login-container', this.firebaseUIConfig)
        }
    }

    // Make sure we un-register Firebase observers when the component unmounts.
    componentWillUnmount() {
        this.unregisterAuthObserver()
        // this.ui.delete()
    }

    onFirebaseSignIn(result, redirectURL) {
        Axios.post('/customer/firebase_login', {
            firebase_uid: result.user.uid,
            name: result.user.displayName
        }).then((res) => {
            this.props.app.loginWithFirebase(result.user.uid)
            alert(lang.login_successful)
            this.props.history.goBack()
        }).catch((error) => console.log(error))
        return false
    }

    render() {
        if (customerId) {
            return <Redirect to={`/profile/${this.props.match.params.tableQR}`} />
        }
        return (
            <div>
                <TopNav
                    tableQR={this.props.match.params.tableQR}
                    title={lang.order}
                    table={this.props.app.state.table}
                    backButton={true}
                    backLabel={lang.back} back={`/category/${this.props.match.params.tableQR}`}
                />
                <div className='col-sm-12'>
                    {
                        customerId && 
                        <div style={{ padding: '50px 10px 10px 10px', marginBottom: "20px", backgroundColor: "white" }}>
                            <h4>You are already signed in.</h4>
                            <p><button class='btn btn-primary text-center' onClick={() => this.props.history.push(`/profile/${this.props.match.params.tableQR}`)}>Go to My Profile</button></p>
                        </div> ||
                        <div style={{ padding: '50px 10px 10px 10px', marginBottom: "20px", backgroundColor: "white" }}>
                            <h4>{lang.encourage_sign_in}</h4>
                            <div id='firebaseui-login-container'></div>
                        </div>
                    }
                </div>
                <div style={{textAlign:"center"}}>
                    <button className="btn btn-primary" onClick={this.showLoginModal}>Login Now</button>
                </div>
                {
                    this.state.loginModal
                }
                {/* {
                    this.state.confirmModal &&
                    <ConfirmModal 
                        ref={this.confirmModalRef}
                        message='Choose your payment method:'
                        buttonLayout="vertical"
                        onClose={() => {
                            this.setState({
                                confirmModal: null
                            })
                        }}
                        onYes={() => {
                            me.props.history.push(`/payment/${me.props.match.params.tableID}`)
                        }}
                        yesText='Pay Online'
                        onNo={() => {
                            me.setState({
                                confirmModal: null
                            }, () => Order.payBill())
                        }}
                        noText='Pay at Counter'
                    />
                } */}
                
            </div>
        )
    }
    showLoginModal = () => {
        this.setState({
            loginModal: <LoginModal
                onClose={() => this.setState({loginModal: null})}
            />
        })
    }
}